define('controllers/requests',['require','mediator','controllers/base/controller','models/pages/requests/index','views/pages/requests/index'],function(require) {
    'use strict';

    var mediator = require('mediator'),
        Controller = require('controllers/base/controller'),
        RequestsPageModel = require('models/pages/requests/index'),
        RequestsPageView = require('views/pages/requests/index');

    var RequestsController = Controller.extend({
        show: function(params) {
            var fromDate, toDate, archive;

            fromDate = new Date(params.fromDate);
            toDate = new Date(params.toDate);

            if (!fromDate.valueOf() || !toDate.valueOf()) {

                var date;

                if (mediator.user.isClientSB()) {
                    date = (new Date().getDate());

                    fromDate = new Date();
                    fromDate.setDate(date - 7);

                    toDate = new Date();
                    toDate.setDate(date + 30);
                } else {
                    date = new Date();

                    toDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
                    fromDate = new Date();
                    fromDate.setTime(toDate.getTime() - 1000 * 60 * 60 * 24 * 14 );
                }
            }

            if (mediator.user.isClientSB() || params.fromDate && params.toDate) {
                archive = true;
            } else {
                archive = false;
            }


            var model = new RequestsPageModel({
                fromDate: fromDate,
                toDate: toDate,
                archive: archive
            });

            this.view = new RequestsPageView({
                model: model
            });

            model.load(true);
        }
    });

    return RequestsController;
});

